import ContactForm from '../../components/contact/ContactForm';
import MainDecorationA from '../../components/decorations/MainDecorationA'
import { useTranslation } from 'react-i18next';

const ContactSection = () => {
    const { t } = useTranslation();
    const contact = t('contact');
    return (
        <div className='position-relative'>
            <MainDecorationA />
            <div className='container py-5'>
                <div className='py-5'>
                    <div className='text-white text-center mb-5 pb-4'>
                        <p className='fw-bold fs-48'>{contact.title}</p>
                        <p className='fw-regular fs-28 mb-1'>{contact.subtitle}</p>
                    </div>
                    <div className='mx-auto contact-main-card bg-opacity'>
                        <div className='row row-cols-1 row-cols-lg-2 g-0 d-flex justify-content-center align-items-center'>
                            <div className='col'>
                                <ContactForm />
                            </div>
                            <div className='col'>
                                <ContactInfo />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const ContactInfo = () => {
    const { t } = useTranslation();

    const contactData = t('contact.list');
    return (
        <div className='d-flex pb-4 pb-lg-0 ps-xl-5'>
            <div className='d-flex flex-column align-items-center align-items-lg-start mx-auto ms-lg-5'>
                {
                    contactData.map((item, index) => {
                        return (
                            <div key={index} className='d-flex flex-column flex-lg-row align-items-center text-white my-3 my-lg-5'>
                                <div className='d-flex contact-icon me-lg-5'>
                                    <i className={`fa-solid ${item.icon} fs-28 m-auto`}></i>
                                </div>
                                <p className='fw-regular fs-20 m-0'>{item.text}</p>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}


export default ContactSection